import React from "react";
import Header from "../../reusable/Header/Header";
import TopBarTab from "../../reusable/TopBarTab/TopBarTab";
import FilenameInputBox from "./InputBox";
import styles from "./TopBar.module.css";
import { secondaryTextColor, fw400, titleS } from "../../../Global.module.css";
import { connect } from "react-redux";
import { updateSlidesMetaData } from "../../../store/actions/updateSlidesMetaData";
import {
	updateAutoSave,
	updateLastSaved,
} from "../../../store/actions/updateAutoSave";
import { updateEditorState } from "../../../store/actions/updateEditorState";
import { useDebouncedCallback } from "use-debounce";
import { updateTitle } from "../../../helpers/api";
import { getLastChanged } from "../../../helpers/getDateTime";
import TabContainer from "../../reusable/TopBarTabContainer/TabContainer";

const EditorPageTopBar = (props) => {
	const updateFilename = async (id, title) => {
		props.updateAutoSave({
			saving: true,
		});
		try {
			await updateTitle(id, title);
		} catch (error) {}
		props.updateAutoSave({
			saving: false,
		});
		props.updateLastSaved({
			lastSaved: Date.now(),
		});
	};

	const debounced = useDebouncedCallback((value) => {
		updateFilename(props.slidesMetaData.id, value);
	}, 2000);

	const handleFilename = (value) => {
		props.updateSlidesMetaData({
			...props.slidesMetaData,
			title: value,
		});
		debounced.callback(value);
	};

	return (
		<Header>
			<div className={styles.topBar}>
				<TabContainer>
					<TopBarTab
						title="Editor"
						active={props.editorState.editor}
						action={() => props.updateEditorState(true)}
					/>
					{/* <TopBarTab
						title="Design"
						active={props.editorState.design}
						action={() => props.updateEditorState(true)}
					/> */}
				</TabContainer>
				<FilenameInputBox
					defaultValue={props.slidesMetaData.title}
					action={handleFilename}
				/>
				<p
					className={`${secondaryTextColor} ${titleS} ${fw400} ${styles.savingState}`}
				>
					{props.autoSave.saving
						? "Saving..."
						: `Last Changed at ${getLastChanged(
								props.autoSave.lastSaved || Date.now()
						  )}`}
				</p>
			</div>
		</Header>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlidesMetaData: (payload) => dispatch(updateSlidesMetaData(payload)),
	updateAutoSave: (payload) => dispatch(updateAutoSave(payload)),
	updateLastSaved: (payload) => dispatch(updateLastSaved(payload)),
	updateEditorState: (payload) => dispatch(updateEditorState(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorPageTopBar);
